
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Cavepaintings=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Cave Rock Painting</h1>
           <p className="sub-heading">Over 4000 years old Rock paintings, showing culture</p>
         </div>
         <div className="description">
         The district of Sonbhadra is known for its several Cave painting sites found in the Vindhya region. The Lakhania caves are located in the Kaimur ranges and are known for their beautiful ageless rock paintings. These historic paintings are about 4000 years old and bring to life the culture and belief of an era gone by. Khodwa Pahar or Ghoramangar is another well-known ancient cave painting site. The Northern Vindhyas have the greatest number of rock shelters with cave paintings in North India. Most of the art here ranges from the Mesolithic to the Heliolithic Age. The Vindhya and Kaimur ranges have around 250 rock shelters scattered across the districts of Allahabad, Mirzapur, Chandauli, Rewa and Sonbhadra. Most of the rock-art caves in the Vindhya-Kaimur ranges were discovered by British archaeologist Archibald Carlleyle in the 19th century.

Sonbhadra district has preserved these ancient rock shelters and archaeologists still refer to it as the ‘rock art hub of Uttar Pradesh’. The most significant sites in the district include the Panchmukhi rock shelters, Kauwa Khoh rock shelters, Lakhania rock shelters, Lakhma caves, etc. The cave paintings of Sonbhadra primarily depict scenes of hunting, war, festivals, dance, romantic life and animals. These paintings reflect the tribal culture of the region, and there are many tribal communities still living in the hills of Sonbhadra including the Gond, Chero, Buksa, Jaunsari, Kharwar, Pankha and Patari tribes.

  </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>

           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Canvas Rock Painting/rock4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};